import { CSSProperties } from 'react'

export const s = {
  root: {
    marginTop: 20,
    marginLeft: 12,
    marginBottom: 40,
  },
  details: {
    marginBottom: 24,
    display: 'grid',
    gridTemplateColumns: '72px 1fr 62px 1fr 86px 1fr',
    gridTemplateAreas: '"location address budget amount attendees number"',
    columnGap: 10,
  } as CSSProperties,
  requests: {
    marginBottom: 24,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
  } as CSSProperties,
  header: {
    marginTop: 24,
  },
  paragraph: {
    marginTop: 6,
  },
}
